import { VehicleOfficeWorkingDayViewModel } from '@api/index';

export const getTimes = () => {
  const times: string[] = [];
  for (let i = 0; i < 24; i++) {
    const hour = i < 10 ? `0${i}` : `${i}`;
    times.push(`${hour}:00`, `${hour}:30`);
  }
  return times;
};

export const timeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};
export const getCurrentTime = () => {
  const now = new Date();
  let hours = now.getHours();
  let minutes = now.getMinutes();

  if (minutes === 0) {
    minutes = 0;
  } else if (minutes > 0 && minutes <= 30) {
    minutes = 30;
  } else {
    minutes = 0;
    hours += 1;
  }

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
};

export const getNearestAvailableTime = (availableTimes: string[]) => {
  const currentTime = getCurrentTime();
  return (
    availableTimes.find((time) => time >= currentTime) || availableTimes[0]
  );
};

export const getAvailableTimesBetween = (
  startTime: string,
  finishTime: string
) => {
  const times = getTimes();
  const startMinutes = timeToMinutes(startTime);
  const finishMinutes = timeToMinutes(finishTime);

  return times.filter((time) => {
    const timeMinutes = timeToMinutes(time);
    return timeMinutes >= startMinutes && timeMinutes <= finishMinutes;
  });
};

const roundTime = (time: string, isStart: boolean) => {
  if (!time) return '';

  const [hour, minute] = time.split(':').map(Number);
  if (isStart) {
    if (minute === 0) {
      return `${hour.toString().padStart(2, '0')}:00`;
    }
    return minute < 30
      ? `${hour.toString().padStart(2, '0')}:30`
      : `${(hour + 1).toString().padStart(2, '0')}:00`;
  } else {
    return minute > 30
      ? `${hour.toString().padStart(2, '0')}:30`
      : `${hour.toString().padStart(2, '0')}:00`;
  }
};

export const getAvailableTimes = (
  workingDay?: VehicleOfficeWorkingDayViewModel,
  selectedDate?: Date
) => {
  const times = getTimes();

  if (!workingDay?.startTime || !workingDay?.finishTime || !selectedDate) {
    return times;
  }
  // it's closed all day
  if (workingDay.startTime === '00:00' && workingDay.finishTime === '00:00') {
    return [];
  }

  const startTime = roundTime(workingDay.startTime, true);
  const finishTime = roundTime(workingDay.finishTime, false);

  const startMinutes = timeToMinutes(startTime);
  const finishMinutes = timeToMinutes(finishTime);

  let availableTimes: string[];
  if (startMinutes === 0 && finishMinutes === 1439) {
    availableTimes = times;
  } else if (startMinutes > finishMinutes) {
    availableTimes = times.filter((t) => {
      const currentMinutes = timeToMinutes(t);
      return (
        (currentMinutes >= startMinutes && currentMinutes < 1440) ||
        (currentMinutes >= 0 && currentMinutes <= finishMinutes)
      );
    });
  } else {
    availableTimes = times.filter((t) => {
      const currentMinutes = timeToMinutes(t);
      return currentMinutes >= startMinutes && currentMinutes <= finishMinutes;
    });
  }

  const now = new Date();
  const selectedDateObject = selectedDate ? new Date(selectedDate) : null;

  if (
    selectedDateObject &&
    now.toDateString() === selectedDateObject.toDateString()
  ) {
    const currentTime = getCurrentTime();
    const currentMinutes = timeToMinutes(currentTime);

    availableTimes = availableTimes.filter(
      (t) => timeToMinutes(t) >= currentMinutes
    );
  }

  return availableTimes.length > 0 ? availableTimes : times;
};
